import { render, staticRenderFns } from "./AddEditStockIn.vue?vue&type=template&id=0b7fa6ca&scoped=true"
import script from "./AddEditStockIn.vue?vue&type=script&lang=js"
export * from "./AddEditStockIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fa6ca",
  null
  
)

export default component.exports